
import CommunityBadge from '~/components/community/CommunityBadge.vue';
import IconArrowRight from '~/components/icons/IconArrowRight.vue';
export default {
  components: { IconArrowRight, CommunityBadge }

};
